import {Box} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';

const Spin = ({...props}) => {
  return (
    <>
      {
        props?.isLoading ?
          <Box mt={2} className="flex justify-center">
          <CircularProgress sx={{color: '#283665',}} size={34} color="inherit"/>
        </Box>
        : props?.children
      }
    </>
  );
}

export default Spin;
